import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ApiUrlHelper } from '../api-url-helper';
import { HttpClientHelper } from '../http-helper';
import { VotingService, VotingType } from '../voting/voting.service';
import { CommentTransFormer } from '../../_transformers/comment.transformer';
import { map, delay } from 'rxjs/operators';
import { Utility } from '../utility';

@Injectable()
export class CommentService {
    constructor(
        private _apiUrlHelper: ApiUrlHelper,
        private _votingService: VotingService,
        private _commentTransFormer: CommentTransFormer,
        private _httpClientHelper: HttpClientHelper,
        private _utility:Utility
    ) { }

    likeComment(cid, isVideo?, isAlbumActivity?, cinemaId?): Observable<any> {
        const apiURL = this._apiUrlHelper.urlBuilder('comment-like', {
            pid: cid,
            cinema: !!isAlbumActivity ? '7' : !!cinemaId ? cinemaId : null,
        }, (this._utility.isNews || isVideo) ? "NEWS_ENDPOINT" : "");
        return this._httpClientHelper.get(apiURL)
            .pipe(map((res) => {
                this._votingService.vote(VotingType.LikeComment, cid);
                return res;
            })).pipe(delay(this.delaySomeMillsecond(200)));
    }

    publishComment(user, videoId, Context, isAlbum?): Observable<any> {
        var apiURL = this._apiUrlHelper.urlBuilder('comment-publish', { cinema: isAlbum ? '7' : '1' }, this._utility.isNews ? "NEWS_ENDPOINT" : "");

        return this._httpClientHelper.post(apiURL, {
            Contxt: Context,
            videoID: videoId,
            // uid: user.id,
            // gid: user.token.gid,
            // expire: user.token.expire,
            // sign: user.token.sign,
            // token: user.token.token,
            sDate: user.registerDate,
            a: 1,
        }, null)
            .pipe(map((res) => {
                return res[0];
            })).pipe(delay(this.delaySomeMillsecond(200)));
    }

    replyComment(user, commentId, Context, isVideo?, isAlbum?): Observable<any> {
        const apiURL = this._apiUrlHelper.urlBuilder('comment-reply', { cinema: isAlbum ? '7' : '1' }, (this._utility.isNews || isVideo) ? "NEWS_ENDPOINT" : "");
        return this._httpClientHelper.post(apiURL, {
            contxt: Context,
            pid: commentId,
            sDate: user.registerDate,
            a: 1
        }, null)
            .pipe(map((res) => {
                return res[0];
            }))
            .pipe(
                delay(this.delaySomeMillsecond(200))
            );
    }

    removeComment(user, cid, type = 1, isVideo?): Observable<any> {
        const apiURL = this._apiUrlHelper.urlBuilder('comment-delete', {
            type: type,
            // uid: user.id,
            // gid: user.token.gid,
            // expire: user.token.expire,
            // sign: user.token.sign,
            // token: user.token.token,
            id: cid
        }, (this._utility.isNews || isVideo) ? "NEWS_ENDPOINT" : "");
        return this._httpClientHelper.get(apiURL)
            .pipe(map((res) => {
                return res[0];
            })).pipe(delay(this.delaySomeMillsecond(400)));
    }

    getCommentById(cid): Observable<any> {
        const apiURL = this._apiUrlHelper.urlBuilder('get-comment-by-id', {
            replyid: cid,
            a: this._utility.isNews ? '1' : '',
        }, this._utility.isNews ? "NEWS_ENDPOINT" : "");
        return this._httpClientHelper.get(apiURL)
            .pipe(map((res) => {
                return this._commentTransFormer.fromGetCommentById(res[0]);
            })).pipe(delay(this.delaySomeMillsecond(200)));
    }

    reportComment(id: string | number, ToUid: string | number, reason: string) {
        const apiURL = this._apiUrlHelper.urlBuilder('report-comment', {
            CommentID: id,
            ToUid,
            Reason: reason
        });
        return this._httpClientHelper.get(apiURL)
            .pipe(map((res) => {
                return res;
            }));
    }


    getCommentByParentID(id, parentID, parentUID, page = 2, size = 3, isAlbum?) {
        const apiURL = this._apiUrlHelper.urlBuilder('get-comment-by-parentid', {
            id,
            parentID,
            parentUID,
            page,
            size,
            cinema: isAlbum ? '7' : '1'
        }, this._utility.isNews ? "NEWS_ENDPOINT" : "");
        return this._httpClientHelper.get(apiURL)
            .pipe(map((res) => {
                return res.map(p => this._commentTransFormer.fromList(p, this._utility.isNews));
            })).pipe(delay(this.delaySomeMillsecond(300)));
    }

    delaySomeMillsecond(millsec): Date {
        var dateObj = Date.now();
        dateObj += millsec;
        return new Date(dateObj);

    }
}
